import React, { useState } from 'react'
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux'
import { toast } from 'react-toastify'
import { withRouter } from 'react-router-dom'

import { RootState } from 'state/types'

import {
  ApiResponse,
  post,
} from 'utils/apis/insuranceLounge'

import {
  Applicant,
  SuggestInsurance,
} from 'state/quotes/types'
import { setCurrentQuoteRequestEntry } from 'state/quotes/actions'
import { getQuoteRequestValue } from 'state/quotes/selectors'

import { ContainerProps } from './types'

import SuggestInsuranceForm from './index.presentational'

const SuggestInsuranceFormContainer: React.FC<ContainerProps> = ({ history }): React.ReactElement => {
  const dispatch = useDispatch()

  const [
    isSubmitting,
    setSubmitting,
  ] = useState(false)

  const [
    applicantEmail,
    emailAddress,
    comments,
    firstName,
    lastName,
    zipCode,
  ] = useSelector((state: RootState) => {
    const applicant: Applicant = getQuoteRequestValue(state, 'applicant')
    const suggestInsurance: SuggestInsurance = getQuoteRequestValue(state, 'other.suggestInsurance')

    return [
      applicant.address.email,
      suggestInsurance.email,
      suggestInsurance.comments,
      applicant.personalInfo.name.firstName,
      applicant.personalInfo.name.lastName,
      applicant.address.zipCode,
    ]
  }, shallowEqual)

  if (emailAddress === undefined && applicantEmail) {
    dispatch(setCurrentQuoteRequestEntry('other.suggestInsurance.email', applicantEmail))
  }

  const onSubmit = (): Promise<boolean | void> => {
    setSubmitting(true)

    return post('/insurance-type-suggestions', {
      first_name: firstName, // eslint-disable-line @typescript-eslint/camelcase
      last_name: lastName, // eslint-disable-line @typescript-eslint/camelcase
      email_address: emailAddress, // eslint-disable-line @typescript-eslint/camelcase
      zip_code: zipCode, // eslint-disable-line @typescript-eslint/camelcase
      comments,
    })
      .then((resp: ApiResponse) => {
        if (!resp.success) {
          return Promise.reject(resp.firstErrorMessage || 'Unable to save your suggestion.')
        }

        history.push('/suggest-insurance/success')

        return Promise.resolve(true)
      })
      .catch(errorMessage => {
        toast(errorMessage)

        setSubmitting(false)
      })
  }

  return React.createElement(
    SuggestInsuranceForm,
    {
      applicantEmail,
      isSubmitting,
      onSubmit,
    },
  )
}

export default withRouter(SuggestInsuranceFormContainer)
